import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1185.47059,112.941176 L1185.47059,564.705882 L1637.23529,564.705882 L1637.23529,1807.05882 L846.872941,1807.05882 L846.872941,1468.23529 L959.588235,1468.23529 L959.588235,1355.29412 L846.872941,1355.29412 L846.872941,1242.35294 L959.588235,1242.35294 L959.588235,1129.41176 L846.872941,1129.41176 L846.872941,1016.47059 L959.588235,1016.47059 L959.588235,903.529412 L846.872941,903.529412 L846.872941,790.588235 L959.588235,790.588235 L959.588235,677.647059 L846.872941,677.647059 L846.872941,441.261176 C912.378824,417.882353 959.588235,355.764706 959.588235,282.352941 L959.588235,112.941176 L1185.47059,112.941176 Z M620.764706,112.941176 L620.764706,282.352941 C620.764706,355.990588 668.2,418.108235 733.931765,441.487059 L733.931765,564.705882 L620.764706,564.705882 L620.764706,677.647059 L733.931765,677.647059 L733.931765,790.588235 L620.764706,790.588235 L620.764706,903.529412 L733.931765,903.529412 L733.931765,1016.47059 L620.764706,1016.47059 L620.764706,1129.41176 L733.931765,1129.41176 L733.931765,1242.35294 L620.764706,1242.35294 L620.764706,1355.29412 L733.931765,1355.29412 L733.931765,1468.23529 L620.764706,1468.23529 L620.764706,1581.17647 L733.931765,1581.17647 L733.931765,1807.05882 L281.941176,1807.05882 L281.941176,112.941176 L620.764706,112.941176 Z M1298.41176,136.32 L1613.85647,451.764706 L1298.41176,451.764706 L1298.41176,136.32 Z M846.647059,112.941176 L846.647059,282.352941 C846.647059,313.524706 821.235294,338.823529 790.176471,338.823529 C759.117647,338.823529 733.705882,313.524706 733.705882,282.352941 L733.705882,112.941176 L846.647059,112.941176 Z M1700.59529,378.804706 L1371.48471,49.5811765 C1339.86118,18.0705882 1296.26588,-5.68434189e-14 1251.65412,-5.68434189e-14 L959.588235,-5.68434189e-14 L620.764706,-5.68434189e-14 L169,-5.68434189e-14 L169,1920 L1750.17647,1920 L1750.17647,498.522353 C1750.17647,453.345882 1732.55765,410.767059 1700.59529,378.804706 L1700.59529,378.804706 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconZippedLine = /*#__PURE__*/function (_Component) {
  _inherits(IconZippedLine, _Component);

  var _super = _createSuper(IconZippedLine);

  function IconZippedLine() {
    _classCallCheck(this, IconZippedLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconZippedLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconZipped",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconZippedLine.displayName = "IconZippedLine";
  return IconZippedLine;
}(Component);

IconZippedLine.glyphName = 'zipped';
IconZippedLine.variant = 'Line';
IconZippedLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconZippedLine;
export { IconZippedLine };